import { render } from "./SynergyItsFeaturedComp.vue?vue&type=template&id=5d556a6e&scoped=true"
import script from "./SynergyItsFeaturedComp.vue?vue&type=script&lang=js"
export * from "./SynergyItsFeaturedComp.vue?vue&type=script&lang=js"

import "./SynergyItsFeaturedComp.vue?vue&type=style&index=0&id=5d556a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d556a6e"]])

export default __exports__